import { ChangeDetectorRef, Component ,OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TFMService } from 'app/mock-api/tfm.service';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { FilterPipe } from 'app/pipes/filter.pipe';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'resources-agencies',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule,FilterPipe,MatSlideToggleModule,MatMenuModule, MatIconModule,MatButtonModule],
  templateUrl: './agencies.component.html',
  styleUrl: './agencies.component.scss'
})
export class ResourcesAgenciesComponent implements OnInit {
  public view: any = {
  
    filterText: "",
    agencies:[],
    agenciesFiltered: [],
  }
  // agencies: any;
  agencyID: any;
  siteID: any;
  siteGUID: any;
  
  

  constructor(private tfmService: TFMService, private _cd: ChangeDetectorRef,private router: Router) { }
  
  ngOnInit(): void {
    this.getAgency();
  }

  getAgency() {
    this.tfmService.getAgencies().subscribe(
      (res) => {
        this.view.agencies = res.content; //Full agencies + sites list

        this.filter(null);
        
        this.view.agencies = res;

        this.tfmService.log("Agencies",this.view.agencies.content)

        this._cd.detectChanges();
      },
      (error) => {
        console.error('Error fetching agencies:', error);
      }
    );
  }
  public filter(e) {
    if (this.view.filterText) {
      // Clone the agencies array to avoid mutating the original
        this.tfmService.log(Array.isArray(this.view.agencies)); 
        let agenciesFiltered = this.view.agencies.map(agency => {
            // Filter sites based on the filterText
            return {
                ...agency,
                sites: agency.sites.filter(site => site.name.toLowerCase().includes(this.view.filterText.toLowerCase()))
            };
        });
        this.view.agenciesFiltered = agenciesFiltered;
    } else {
        // If no filter text, show all agencies
        this.view.agenciesFiltered = this.view.agencies;
    }
    // Trigger change detection if necessary
    this._cd.detectChanges();

  }


  navigateToClient(site) {

    this.changeSite(site).then(() => {

      const url = `/${site.agencyID}/${site.code}`;
      window.open(url, '_blank');
    });
    // this.router.navigateByUrl(url);
  }

  public changeSite(site): Promise<void> {
    return new Promise((resolve, reject) => {
      this.tfmService.changeSite(site);
      setTimeout(() => {
        window.location.reload();
        resolve();
      }, 1000);
    });
  }

  onView(channel: any) {
    // Implement view logic
    console.log('View', channel);
     this.router.navigate(['/resources/agency-detail', channel.guid]);
  }

  onEdit(channel: any) {
      // Implement edit logic
      console.log('Edit', channel);
  }

  onDelete(channel: any) {
      // Implement delete logic
      console.log('Delete', channel);
  }
}
